import { jsx, jsxs } from "react/jsx-runtime";
import {
  Avatar,
  Tag,
  TagPicker,
  TagPickerControl,
  TagPickerGroup,
  TagPickerInput,
  TagPickerList,
  TagPickerOption,
  __css
} from "@fluentui/react-components";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { isolate } from "../../shell/external-space-banner.js";
import { initialsOf } from "../internal/initials.js";
const useStyles = __css({"root":{"Bgto7am":"fuzgk9b"}});
function UserPicker({
  options,
  value,
  onChange,
  label,
  disabled = false,
  className
}) {
  const { t } = useTranslation("ui");
  const styles = useStyles();
  const [query, setQuery] = useState("");
  const byId = new Map(options.map((option) => [option.id, option]));
  const selected = value.map((id) => byId.get(id) ?? { id, label: id });
  const needle = query.trim().toLowerCase();
  const available = options.filter(
    (option) => !value.includes(option.id) && option.label.toLowerCase().includes(needle)
  );
  const handleSelect = (_event, data) => {
    setQuery("");
    onChange(data.selectedOptions);
  };
  return /* @__PURE__ */ jsxs(TagPicker, { disabled, selectedOptions: [...value], onOptionSelect: handleSelect, children: [
    /* @__PURE__ */ jsxs(
      TagPickerControl,
      {
        className: className ?? styles.root,
        expandIcon: { "aria-label": t("components.userPicker.open", { label }) },
        children: [
          /* @__PURE__ */ jsx(TagPickerGroup, { "aria-label": label, children: selected.map((person) => /* @__PURE__ */ jsx(
            Tag,
            {
              shape: "rounded",
              value: person.id,
              media: /* @__PURE__ */ jsx(
                Avatar,
                {
                  "aria-hidden": "true",
                  name: person.label,
                  initials: initialsOf(person.label),
                  size: 20
                }
              ),
              dismissIcon: {
                "aria-label": t("components.userPicker.remove", { name: isolate(person.label) })
              },
              children: person.label
            },
            person.id
          )) }),
          /* @__PURE__ */ jsx(
            TagPickerInput,
            {
              "aria-label": label,
              placeholder: t("components.userPicker.placeholder"),
              value: query,
              onChange: (event) => {
                setQuery(event.target.value);
              }
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx(TagPickerList, { children: available.length > 0 ? available.map((option) => /* @__PURE__ */ jsx(
      TagPickerOption,
      {
        value: option.id,
        text: option.label,
        media: /* @__PURE__ */ jsx(
          Avatar,
          {
            "aria-hidden": "true",
            name: option.label,
            initials: initialsOf(option.label),
            size: 24
          }
        ),
        children: option.label
      },
      option.id
    )) : t("components.userPicker.noOptions") })
  ] });
}
export {
  UserPicker
};
//# sourceMappingURL=user-picker.js.map

import "/opt/batiflow/app/packages/ui/dist/components/user-picker/user-picker.griffel.css";